import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=e12365b8&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=e12365b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12365b8",
  null
  
)

export default component.exports